// extracted by mini-css-extract-plugin
module.exports = {"root":"bc_bJ","body":"bc_h"};